module.exports = __webpack_public_path__ + "static/img/track_cn_yellow.0cb8103c.png";